import {
  Checkbox,
  MessageBar,
  MessageBarType,
  TextField,
} from "@fluentui/react";
import { APP_NAME } from "../../Constants/Generic";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ApiService from "../../Services/ApiService";
import { IAPIResponse } from "../../Services/AjaxService";
import Loadable from "../../Components/Loadable/Loadable";
import { ToastMessage } from "../../Utils/UIMessages";
import { AppRoutes } from "../../Constants/AppRoutes";
import { useDispatch } from "react-redux";
import { GenericActions } from "../../Redux/Generic/GenericAction";
import { IUser } from "../../Models/IUser";
import "./LoginPage.scss";
import { Encript } from "../../Utils/Cripto";

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userIdentifier, setUserIdentifier] = useState<string>("");
  const [userPassword, setUserPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const obtainUser = (response: any) => {
    localStorage.setItem("sessionToken", response.token);
    let user: IUser = response.user;
    dispatch(GenericActions.setUser(user) as any);
    navigate(AppRoutes.APP_LANDING_PAGE);
  };

  const doLogin = () => {
    setLoading(true);
    ApiService.SessionController.Login(
      userIdentifier,
      userPassword,
      (response: IAPIResponse) => {
        if (response.error === null && response.raw.status === 200) {
          if (localStorage.getItem("remember-me") === "true") {
            localStorage.setItem(
              "autologin",
              JSON.stringify({
                user: userIdentifier,
                token: Encript(userPassword),
              })
            );
          } else {
            localStorage.removeItem("autologin");
          }

          obtainUser(response.parsed);
          ToastMessage("success", "Accesso avvenuto con successo.");
        } else {
          ToastMessage("error", "Login fallito, verificare le credenziali.");
        }
        setLoading(false);
      }
    );
  };

  // «Sessione continua»: chi l'ha scelta e non e' uscito entra direttamente nella Home, anche aprendo l'app
  // dall'icona (che parte da questa pagina). Se la sessione sul server e' scaduta, alla prima chiamata l'app
  // rifa' l'accesso da sola (refreshToken); se non ci riesce torna qui con «Sessione scaduta» (titolare, 01/11/2026).
  const [resume] = useState<boolean>(
    () =>
      localStorage.getItem("remember-me") === "true" &&
      !!localStorage.getItem("sessionToken") &&
      !!localStorage.getItem("loggedUser") &&
      !(window as any)["SessionExpired"]
  );

  useEffect(() => {
    if (resume) {
      navigate(AppRoutes.APP_LANDING_PAGE, { replace: true });
      return;
    }
    dispatch(GenericActions.setUser(undefined) as any);
  }, []);

  if (resume) return null;

  return (
    <div>
      <div
        className="login-page-medical-background"
      >
        <div className="center-content fill-page-height">
          <div className="card smooth-background">
            <div className="login-card-content">
              <div className="app-generic-title">Accedi a {APP_NAME}</div>
              <div style={{ textAlign: "right", fontSize: "0.7em", opacity: 0.4 }}>
                v{process.env.REACT_APP_VERSION}
              </div>
              <img style={{ width: "100%" }} src={"./assets/logo_main.png"} alt="Domino" />
              <div className="login-product-name">{APP_NAME}</div>
              <div style={{ marginTop: "1em" }}></div>
              {(window as any)["SessionExpired"] && (
                <MessageBar messageBarType={MessageBarType.error}>
                  Sessione scaduta: eseguite nuovamente il login.
                </MessageBar>
              )}
              <Loadable
                isLoading={loading}
                content={
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      doLogin();
                    }}
                  >
                    <TextField
                      label="Nome utente"
                      placeholder="Nome utente"
                      required
                      disabled={loading}
                      onChange={(e: any, t) => {
                        if (t !== undefined) {
                          setUserIdentifier(t);
                        }
                      }}
                    />
                    <TextField
                      label="Password"
                      placeholder="Password"
                      type="password"
                      required
                      disabled={loading}
                      onChange={(e: any, t) => {
                        if (t !== undefined) {
                          setUserPassword(t);
                        }
                      }}
                    />
                    <div style={{ marginTop: "1em" }}>
                      <Checkbox
                        label="Sessione continua"
                        defaultChecked={
                          localStorage.getItem("remember-me") === "true"
                        }
                        onChange={(e, c) => {
                          localStorage.setItem(
                            "remember-me",
                            c ? "true" : "false"
                          );
                        }}
                      />
                    </div>

                    <div className="login-form-low-pannel">
                      <div>
                        <Link
                          target="_blank"
                          to={"https://www.dominolabs.it/contatti/"}
                        >
                          Supporto
                        </Link>
                        <span> | </span>
                        <Link target="_blank" to={"https://www.dominolabs.it"}>
                          Chi siamo
                        </Link>
                      </div>
                      <PrimaryButton className="login-submit" type="submit" text="Accedi" />
                    </div>
                  </form>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
